import {
  BoardTypes, ListMemberBoardType, PayloadBoardTypes, PayloadDeleteMemberType, PayloadDuplicateBoardTypes, PayloadGetBoard, PayloadMemberType, ResponseMutationBoard,
} from 'components/types/boardList';
import { http } from 'helpers/http';

const URL = process.env.REACT_APP_API;
const URL_V2 = process.env.REACT_APP_API_V2;

export const apiBoard = {
  boardList: 'board/list',
  boardMember: 'board/list-member',
  createBoard: 'board/create',
  updateBoard: 'board/update',
  deleteBoard: 'board/delete',
  duplicateBoard: 'board/duplicate',
  inviteMemberBoard: 'board/invite',
  deleteMemberBoard: 'board/delete-member',
};

export const boardService = {
  getBoardList: async (payload: PayloadGetBoard): Promise<BoardTypes[]> => {
    const response = await http.post(`${URL_V2}${apiBoard.boardList}`, payload);
    const safeData = Array.isArray(response.data?.data) ? response.data?.data : [];

    return safeData;
  },

  createBoard: async (payload: PayloadBoardTypes): Promise<ResponseMutationBoard> => {
    const response = await http.post(`${URL}${apiBoard.createBoard}`, payload);

    return response.data;
  },

  updateBoard: async (payload: PayloadBoardTypes): Promise<ResponseMutationBoard> => {
    const response = await http.post(`${URL}${apiBoard.updateBoard}`, payload);

    return response.data;
  },

  deleteBoard: async (payload: PayloadGetBoard): Promise<ResponseMutationBoard> => {
    const response = await http.post(`${URL}${apiBoard.deleteBoard}`, payload);

    return response.data;
  },

  duplicateBoard: async (payload: PayloadDuplicateBoardTypes): Promise<ResponseMutationBoard> => {
    const response = await http.post(`${URL}${apiBoard.duplicateBoard}`, payload);

    return response.data;
  },

  getMemberBoard: async (payload: PayloadGetBoard): Promise<ListMemberBoardType[]> => {
    const response = await http.post(`${URL}${apiBoard.boardMember}`, payload);

    return response.data?.data ?? response.data;
  },

  inviteMemberBoard: async (payload: PayloadMemberType): Promise<ResponseMutationBoard> => {
    const response = await http.post(`${URL}${apiBoard.inviteMemberBoard}`, payload);

    return response.data;
  },

  deleteMemberBoard: async (payload: PayloadDeleteMemberType): Promise<ResponseMutationBoard> => {
    const response = await http.post(`${URL}${apiBoard.deleteMemberBoard}`, payload);

    return response.data;
  },
};
